import { createContext } from "react";

/** Setter della barra di /visite. Nell'Admin il contesto non c'è. */
export const VisiteChromeContext = createContext(null);
